import { useCallback } from 'react';
import { registerMutation, useMutation } from 'data-fetching-client';
import { authorizeUberconference } from '../uberconferenceApi';
const AUTHORIZE_UBERCONFERENCE = registerMutation({
  fieldName: 'authorizeUberconference',
  args: ['code'],
  fetcher: authorizeUberconference
});
export const useAuthorizeUberconference = () => {
  const [authorize, {
    loading,
    error
  }] = useMutation(AUTHORIZE_UBERCONFERENCE);
  const authorizeAccount = useCallback(code => {
    return authorize({
      variables: {
        code
      }
    });
  }, [authorize]);
  return {
    authorizeAccount,
    updating: loading,
    error
  };
};